(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vanta-discount-popup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const popup = document.querySelector('[data-discount-popup]');
    const tab = document.querySelector('[data-discount-popup-tab]');
    if (!popup) return;

    // localStorage (not sessionStorage): once a visitor closes the popup —
    // docking the shaking tab — or dismisses the tab itself, that choice
    // persists across browser sessions, not just the current tab/visit.
    const SHOWN_KEY = 'discount-popup-shown';
    const START_KEY = 'discount-popup-start';
    const EXPIRED_KEY = 'discount-popup-expired';
    const TAB_DISMISSED_KEY = 'discount-popup-tab-dismissed';

    const delay = (parseInt(popup.dataset.delay, 10) || 60) * 1000;
    const countdownSeconds = parseInt(popup.dataset.countdown, 10) || 60;

    const minutesEl = popup.querySelector('[data-countdown-minutes]');
    const secondsEl = popup.querySelector('[data-countdown-seconds]');
    let countdownTimer = null;

    function renderCountdown(remaining) {
      const mins = Math.floor(remaining / 60);
      const secs = remaining % 60;
      if (minutesEl) minutesEl.textContent = String(mins).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(secs).padStart(2, '0');
    }

    function isExpired() {
      try {
        return localStorage.getItem(EXPIRED_KEY) === '1';
      } catch (err) {
        return false;
      }
    }

    function markExpired() {
      try {
        localStorage.setItem(EXPIRED_KEY, '1');
      } catch (err) {
        // localStorage unavailable — the offer just won't self-delete.
      }
    }

    function getStart() {
      let start;
      try {
        start = sessionStorage.getItem(START_KEY);
      } catch (err) {
        start = null;
      }
      if (!start) {
        start = String(Date.now());
        try {
          sessionStorage.setItem(START_KEY, start);
        } catch (err) {
          // sessionStorage unavailable — countdown will restart each open.
        }
      }
      return parseInt(start, 10);
    }

    // The countdown is anchored to a fixed start timestamp, not a counter —
    // closing and reopening the popup (via the docked tab) picks up from
    // real elapsed time instead of resetting back to the full duration.
    function startCountdown() {
      clearInterval(countdownTimer);
      const start = getStart();

      function tick() {
        const elapsed = Math.floor((Date.now() - start) / 1000);
        const remaining = countdownSeconds - elapsed;
        if (remaining <= 0) {
          renderCountdown(0);
          clearInterval(countdownTimer);
          markExpired();
          close();
          hideTab();
          return;
        }
        renderCountdown(remaining);
      }

      tick();
      countdownTimer = setInterval(tick, 1000);
    }

    let tabDismissed = false;
    try {
      tabDismissed = localStorage.getItem(TAB_DISMISSED_KEY) === '1';
    } catch (err) {
      tabDismissed = false;
    }

    function showTab() {
      if (tab && !tabDismissed && !isExpired()) tab.hidden = false;
    }

    function hideTab() {
      if (tab) tab.hidden = true;
    }

    function dismissTab() {
      tabDismissed = true;
      hideTab();
      try {
        localStorage.setItem(TAB_DISMISSED_KEY, '1');
      } catch (err) {
        // localStorage unavailable — tab will just reappear next open.
      }
    }

    function open() {
      if (isExpired() || tabDismissed) return;
      document.body.classList.add('discount-popup-open');
      hideTab();
      startCountdown();
    }

    function close() {
      document.body.classList.remove('discount-popup-open');
      clearInterval(countdownTimer);
      try {
        localStorage.setItem(SHOWN_KEY, '1');
      } catch (err) {
        // localStorage unavailable — popup will just show again next open.
      }
      showTab();
    }

    let alreadyShown = false;
    try {
      alreadyShown = localStorage.getItem(SHOWN_KEY) === '1';
    } catch (err) {
      alreadyShown = false;
    }

    // If the form was just submitted (page reloaded with a result), open
    // immediately so the confirmation is visible. A visitor who has
    // permanently dismissed the tab never sees the popup again. Otherwise a
    // returning visitor who already saw it gets the tab instead of the
    // timed popup nagging them again — unless the offer has already
    // expired, in which case it's gone entirely.
    const justSubmitted = popup.querySelector('.discount-popup__message');
    if (tabDismissed || isExpired()) {
      // Permanently dismissed, or already ran its course — nothing to show.
    } else if (justSubmitted) {
      open();
    } else if (alreadyShown) {
      showTab();
    } else {
      setTimeout(open, delay);
    }

    popup.querySelectorAll('[data-discount-popup-close]').forEach((el) => {
      el.addEventListener('click', close);
    });

    const tabOpenBtn = document.querySelector('[data-discount-popup-tab-open]');
    const tabDismissBtn = document.querySelector('[data-discount-popup-tab-dismiss]');
    if (tabOpenBtn) tabOpenBtn.addEventListener('click', open);
    if (tabDismissBtn) tabDismissBtn.addEventListener('click', dismissTab);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && document.body.classList.contains('discount-popup-open')) {
        close();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vanta-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-hero-slideshow]').forEach((hero) => {
      const layers = hero.querySelectorAll('.hero__bg-layer');
      if (layers.length < 2) return;

      let index = 0;
      setInterval(() => {
        layers[index].classList.remove('is-active');
        index = (index + 1) % layers.length;
        layers[index].classList.add('is-active');
      }, 5000);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vanta-product-spotlight"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-product-spotlight]').forEach((section) => {
      const slides = section.querySelectorAll('.product-spotlight__slide');
      const dots = section.querySelectorAll('[data-product-spotlight-dot]');
      if (slides.length < 2) return;

      let index = 0;
      let timer = null;

      function show(next) {
        slides[index].classList.remove('is-active');
        if (dots[index]) dots[index].classList.remove('is-active');
        index = next;
        slides[index].classList.add('is-active');
        if (dots[index]) dots[index].classList.add('is-active');
      }

      function startAutoplay() {
        clearInterval(timer);
        timer = setInterval(() => show((index + 1) % slides.length), 5000);
      }

      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          show(i);
          startAutoplay();
        });
      });

      startAutoplay();
    });

    document.querySelectorAll('[data-sale-countdown]').forEach((el) => {
      const durationMs = (parseFloat(el.dataset.durationHours) || 48) * 60 * 60 * 1000;
      const storageKey = 'vanta-sale-countdown-end';
      let endTime = parseInt(localStorage.getItem(storageKey), 10);

      if (!endTime || endTime < Date.now()) {
        endTime = Date.now() + durationMs;
        localStorage.setItem(storageKey, String(endTime));
      }

      function render() {
        const remaining = Math.max(0, endTime - Date.now());
        const hours = Math.floor(remaining / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        const pad = (n) => String(n).padStart(2, '0');
        el.textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;

        if (remaining <= 0) {
          clearInterval(tickTimer);
          localStorage.removeItem(storageKey);
        }
      }

      render();
      const tickTimer = setInterval(render, 1000);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
